export const uid = () => Math.random().toString(36).slice(2, 10);

const cyrToLat = {"а":"a","б":"b","в":"v","г":"h","ґ":"g","д":"d","е":"e","є":"ye","ж":"zh","з":"z","и":"y","і":"i","ї":"yi","й":"y","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"kh","ц":"ts","ч":"ch","ш":"sh","щ":"shch","ь":"","ю":"yu","я":"ya","ё":"yo","ы":"y","э":"e","ъ":""};

export const toSlug = (str) => str.toLowerCase().split("").map(c => cyrToLat[c] !== undefined ? cyrToLat[c] : c).join("").replace(/[^a-z0-9\s-]+/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");

export const statusMap = {
  READY: { bg: "#dcfce7", color: "#166534", label: "Готов" },
  NOT_ENOUGH_KEYWORDS: { bg: "#fff7ed", color: "#c2410c", label: "Мало кл." },
  GENERATING: { bg: "#dbeafe", color: "#1e40af", label: "⏳" },
  DONE: { bg: "#d1fae5", color: "#065f46", label: "✓ Готово" },
  ERROR: { bg: "#fee2e2", color: "#991b1b", label: "✕ Ошибка" },
  NEEDS_REVIEW: { bg: "#fef9c3", color: "#a16207", label: "⚠ Проверить" },
  EXPANSION: { bg: "#e0e7ff", color: "#4338ca", label: "📐 Расширение" },
};
